var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Runner } from "../../framework/Runner";
import { AnimationTrack } from "../../framework/AnimationTrack";
import { WaitAnimator } from "../../framework/WaitAnimator";
import { RotationAnimator } from "../../framework/RotationAnimator";
export function panoramaViewer(config, durations, rotations, sceneSetup, endWait = 5) {
    return __awaiter(this, void 0, void 0, function* () {
        yield Runner.run(config, (renderer, camera) => __awaiter(this, void 0, void 0, function* () {
            yield sceneSetup(renderer, camera);
            const numSteps = Math.min(durations.length, rotations.length);
            const rTrack = new AnimationTrack();
            for (let i = 0; i < numSteps - 1; i += 1) {
                rTrack.add(durations[i + 1], (beginTime, endTime) => {
                    return RotationAnimator.between(beginTime, endTime, camera, {
                        start: rotations[i],
                        end: rotations[i + 1],
                    });
                });
                rTrack.add(durations[i + 1], WaitAnimator.between);
            }
            rTrack.add(endWait, WaitAnimator.between);
            // Output the tracks
            return [rTrack];
        }));
    });
}
